module.exports = __webpack_public_path__ + "img/icn_drag.fd062f63.svg";